<div class="email-labeling-config-assignment">
  @if (loading()) {
    <div class="loading-container">
      <glxy-loading-spinner size="default"></glxy-loading-spinner>
      <p>{{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.LOADING' | translate }}</p>
    </div>
  } @else {
    @if (error()) {
      <glxy-alert type="error">
        {{ error() }}
      </glxy-alert>
    }

    <div class="assignment-form">
      @if (!readonly()) {
        @if (availableConfigs().length === 0) {
          <glxy-empty-state size="small">
            <glxy-empty-state-title>
              {{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.NO_CONFIGS_AVAILABLE' | translate }}
            </glxy-empty-state-title>
            <glxy-empty-state-actions>
              <button mat-stroked-button (click)="onGoToConfig()">
                {{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.GO_TO_CONFIG' | translate }}
              </button>
            </glxy-empty-state-actions>
          </glxy-empty-state>
        } @else {
          <glxy-form-field>
            <glxy-label>{{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.SELECT_CONFIG' | translate }}</glxy-label>
            <mat-select
              [value]="selectedConfigId()"
              (selectionChange)="onConfigChange($event.value)"
              [disabled]="saving()"
            >
              <mat-option [value]="null"></mat-option>
              @for (config of availableConfigs(); track config.configurationId) {
                <mat-option [value]="config.configurationId">
                  {{ config.name }}
                </mat-option>
              }
            </mat-select>
            @if (selectedConfigId()) {
              <glxy-hint>
                <a [href]="viewDetailsUrlBase() + '/' + selectedConfigId()" target="_blank" rel="noopener noreferrer">
                  {{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.VIEW_DETAILS' | translate }}
                </a>
              </glxy-hint>
            }
          </glxy-form-field>

          <div class="action-buttons">
            <button mat-flat-button color="primary" (click)="onSave()" [disabled]="!hasChanges() || saving()">
              <glxy-button-loading-indicator [isLoading]="saving()">
                {{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.SAVE_CONFIG' | translate }}
              </glxy-button-loading-indicator>
            </button>

            <button mat-button (click)="onCancel()" [disabled]="saving()">
              {{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.CANCEL' | translate }}
            </button>
          </div>
        }
      }
    </div>
  }
</div>
